import React, { useEffect, useState, useCallback } from 'react';
import { Profile } from './profile/index';
import { Referral } from './referral';
import { Preferences } from './preferences';
import { useParams, useHistory } from 'react-router-dom';
import { usePermissions } from 'react-admin';
import NotificationSettings from './profile/notification-settings';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';
import Tabs from '@/components/Tabs';
import { TerminalCredentials } from './terminal-credentials';
import { PaymentDetail } from './payment-details';
import { Notification } from './notification';
import { useSelector } from 'react-redux';

const showPaymentDetails = false;

export default () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { permissions } = usePermissions();

  const userMetas = useSelector((state) => state.reducer.user?.metas);

  const isLoginCredentials = userMetas?.enable_login_credentials?.value === '1';

  const history = useHistory();
  const params = useParams();
  const tabsUrl = params.tabsUrl;

  const handleSelectedTab = useCallback(
    (tab) => {
      if (tab === 0) {
        setSelectedTab(0);
        history.push('/profile');
      }
      if (tab === 1) {
        setSelectedTab(1);
        history.push('/profile/preferences');
      } else if (tab === 2) {
        setSelectedTab(2);
        history.push('/profile/terminal-credentials');
      } else if (tab === 3) {
        setSelectedTab(3);
        history.push('/profile/referral');
      } else if (tab === 4) {
        setSelectedTab(4);
        history.push('/profile/notification');
      } else if (tab === 5) {
        setSelectedTab(5);
        history.push('/profile/payment-detail');
      }
    },
    [history]
  );

  useEffect(() => {
    if (tabsUrl === 'profile') {
      handleSelectedTab(0);
    } else if (tabsUrl === 'preferences') {
      handleSelectedTab(1);
    } else if (tabsUrl === 'terminal-credentials') {
      handleSelectedTab(2);
    } else if (tabsUrl === 'referral') {
      handleSelectedTab(3);
    } else if (tabsUrl === 'notification') {
      handleSelectedTab(4);
    } else if (tabsUrl === 'payment-detail') {
      handleSelectedTab(5);
    }
  }, [tabsUrl, handleSelectedTab]);

  const profileTabItems = [
    {
      title: 'Profile',
      content: <Profile />,
    },
    {
      title: 'Preferences',

      content: <Preferences />,
    },
    ...(isLoginCredentials
      ? [
          {
            title: 'Terminal Credentials',
            content: <TerminalCredentials />,
          },
        ]
      : []),
    {
      title: 'Referral',
      content: <Referral setSelectedTab={handleSelectedTab} />,
    },
    {
      title: 'Notifications',
      content: <Notification />,
    },
    ...(showPaymentDetails
      ? [
          {
            title: 'Payment Detail',
            content: <PaymentDetail />,
          },
        ]
      : []),
  ];

  return (
    <PageContainerAB
      title="Profile"
      mainPage
      minWidth="unset"
      rightContent={
        <a
          className="text-primary-text border-none no-underline  bg-primary-yellow px-4 rounded-md test-sm font-bold h-10 flex items-center justify-center leading-none"
          href="https://apps.microsoft.com/detail/xpdllq9q7xvjlp"
          target="_blank"
          rel="noreferrer">
          Download Windows App
        </a>
      }>
      {permissions === 'admin' ? (
        <div className="mt-4">
          <Profile />
        </div>
      ) : (
        <>
          <div className=" mt-4 flex flex-col gap-4 md:flex-row justify-between items-center mb-6">
            <Tabs
              tabs={profileTabItems}
              selectedTab={selectedTab}
              onTabChange={handleSelectedTab}
              maxWidth="50rem"
            />
            <NotificationSettings />
          </div>

          {profileTabItems[selectedTab]
            ? profileTabItems[selectedTab].content
            : profileTabItems[0].content}
        </>
      )}
    </PageContainerAB>
  );
};
